// Define translations structure
export type Translations = {
  [key: string]: {
    de: string;
    en: string;
  };
};

// Define all translations used in the app
export const translations: Translations = {
  siteTitle: {
    de: 'Hundeschulen Finder',
    en: 'Dog School Finder',
  },
  mainHeading: {
    de: 'Hundeschulen in deiner Nähe',
    en: 'Dog Schools Near You',
  },
  mainHeadingWithCount: {
    de: 'Hundeschulen in deiner Nähe',
    en: 'Dog Schools Near You',
  },
  subHeading: {
    de: 'Finde die besten Hundeschulen in deiner Nähe.',
    en: 'Find the best dog schools in your area.',
  },
  subHeadingWithCount: {
    de: 'Vergleiche Bewertungen und finde den perfekten Hundetrainer in deiner Nähe.',
    en: 'Compare reviews and find the perfect dog trainer in your area.',
  },
  searchPlaceholder: {
    de: 'Postleitzahl eingeben',
    en: 'Enter postal code',
  },
  searchRadius: {
    de: 'Suchradius (km)',
    en: 'Search radius (km)',
  },
  searchButton: {
    de: 'Suchen',
    en: 'Search',
  },
  germanButton: {
    de: 'Deutschland',
    en: 'Germany',
  },
  austriaButton: {
    de: 'Österreich',
    en: 'Austria',
  },
  switzerlandButton: {
    de: 'Schweiz',
    en: 'Switzerland',
  },
  address: {
    de: 'Adresse',
    en: 'Address',
  },
  openingHours: {
    de: 'Öffnungszeiten',
    en: 'Opening Hours',
  },
  phoneNumber: {
    de: 'Telefonnummer',
    en: 'Phone Number',
  },
  website: {
    de: 'Webseite',
    en: 'Website',
  },
  reviews: {
    de: 'Bewertungen',
    en: 'Reviews',
  },
  viewOnMap: {
    de: 'Auf der Karte anzeigen',
    en: 'View on Map',
  },
  languageToggle: {
    de: 'EN',
    en: 'DE',
  },
  states: {
    de: 'Bundesländer',
    en: 'States',
  },
  allDogSchools: {
    de: 'Alle Hundeschulen',
    en: 'All Dog Schools',
  },
  copyright: {
    de: '© 2023 Hundeschulen Finder. Alle Rechte vorbehalten.',
    en: '© 2023 Dog School Finder. All rights reserved.',
  },
  noSchoolsFound: {
    de: 'Keine Hundeschulen gefunden. Versuche es mit einer anderen Suche.',
    en: 'No dog schools found. Try a different search.',
  },
  tableOfContents: {
    de: 'Inhaltsverzeichnis',
    en: 'Table of Contents',
  },
  parking: {
    de: 'Kostenlose Parkplätze',
    en: 'Free Parking',
  },
  accessible: {
    de: 'Rollstuhlgerecht',
    en: 'Wheelchair Accessible',
  },
  privateLesson: {
    de: 'Einzelunterricht',
    en: 'Private Lessons',
  },
  groupLesson: {
    de: 'Gruppenunterricht',
    en: 'Group Lessons',
  },
  dogLicense: {
    de: 'Hundeführerschein',
    en: 'Dog License',
  },
  loading: {
    de: 'Lädt...',
    en: 'Loading...',
  },
  searching: {
    de: 'Suche läuft...',
    en: 'Searching...',
  },
  searchingPostalCode: {
    de: 'Suche nach Postleitzahl',
    en: 'Searching for postal code',
  },
  searchingCity: {
    de: 'Suche nach Ort',
    en: 'Searching for city',
  },
  searchError: {
    de: 'Suchfehler',
    en: 'Search Error',
  },
  pleaseEnterPostalCode: {
    de: 'Bitte gib eine Postleitzahl ein',
    en: 'Please enter a postal code',
  },
  providePostalCodeOrCity: {
    de: 'Bitte gib eine Postleitzahl oder einen Ort ein',
    en: 'Please provide a postal code or city',
  },
  sortAscending: {
    de: 'Aufsteigend',
    en: 'Ascending',
  },
  sortDescending: {
    de: 'Absteigend',
    en: 'Descending',
  },
  startSorting: {
    de: 'Sortierung starten',
    en: 'Start Sorting',
  },
  allSchoolsLoaded: {
    de: 'Alle Hundeschulen geladen',
    en: 'All dog schools loaded',
  },
  searchingAllSchools: {
    de: 'Suche nach allen Hundeschulen',
    en: 'Searching for all dog schools',
  },
  postalCode: {
    de: 'Postleitzahl',
    en: 'Postal Code',
  },
  city: {
    de: 'Ort',
    en: 'City',
  },
  enterPostalCode: {
    de: 'Postleitzahl eingeben',
    en: 'Enter Postal Code',
  },
  enterCity: {
    de: 'Ort eingeben',
    en: 'Enter City',
  },
  error: {
    de: 'Fehler',
    en: 'Error',
  },
  errorFetchingSchools: {
    de: 'Fehler beim Laden der Hundeschulen',
    en: 'Error fetching dog schools',
  },
  errorSearching: {
    de: 'Fehler bei der Suche',
    en: 'Error searching',
  },
  schoolsFound: {
    de: 'Hundeschulen gefunden',
    en: 'Schools Found',
  },
  schoolsLoaded: {
    de: 'Hundeschulen geladen',
    en: 'schools loaded',
  },
  tryDifferentSearch: {
    de: 'Versuche eine andere Suche',
    en: 'Try a different search',
  },
  contact: {
    de: 'Kontakt',
    en: 'Contact',
  },
  contactHeading: {
    de: 'Kontaktiere uns',
    en: 'Contact us',
  },
  contactSubheading: {
    de: 'Hast du Fragen oder Anregungen? Schreib uns!',
    en: 'Do you have any questions or suggestions? Write to us!',
  },
  contactName: {
    de: 'Name',
    en: 'Name',
  },
  contactEmail: {
    de: 'E-Mail-Adresse',
    en: 'Email address',
  },
  contactMessage: {
    de: 'Deine Nachricht',
    en: 'Your message',
  },
  contactSubmit: {
    de: 'Absenden',
    en: 'Submit',
  },
  contactSuccess: {
    de: 'Danke für deine Nachricht! Wir werden uns in Kürze bei dir melden.',
    en: 'Thank you for your message! We will get back to you shortly.',
  },
  // New translations for the city directory
  loadingCities: {
    de: 'Städte werden geladen...',
    en: 'Loading cities...',
  },
  dogSchoolsInGermany: {
    de: 'Hundeschulen in Deutschland',
    en: 'Dog Schools in Germany',
  },
  dogSchoolsInAustria: {
    de: 'Hundeschulen in Österreich',
    en: 'Dog Schools in Austria',
  },
  // New translations for Ratgeber page
  dogGuide: {
    de: 'Hunde-Ratgeber',
    en: 'Dog Guide'
  },
  dogGuideTitle: {
    de: 'Hunde-Ratgeber',
    en: 'Dog Guide'
  },
  dogGuideMetaTitle: {
    de: 'Alles was Sie über Hunde wissen müssen',
    en: 'Everything you need to know about dogs'
  },
  dogGuideMetaDescription: {
    de: 'Umfassender Ratgeber für Hundehalter - Tipps zu Hundeschulen, Ernährung, Pflege, Erziehung und mehr.',
    en: 'Comprehensive guide for dog owners - tips on dog schools, nutrition, care, training and more.'
  },
  dogGuideIntro: {
    de: 'Hier finden Sie umfassende Informationen zu allen wichtigen Themen rund um den Hund. Von Hundeschulen über Ernährung bis hin zu Erziehung und Gesundheit – unser Ratgeber hilft Ihnen, Ihren Vierbeiner bestmöglich zu versorgen.',
    en: 'Here you will find comprehensive information on all important topics related to dogs. From dog schools to nutrition to training and health - our guide helps you take the best possible care of your four-legged friend.'
  },
  topics: {
    de: 'Themen',
    en: 'Topics'
  },
  scientificInsight: {
    de: 'Wissenschaftliche Erkenntnis',
    en: 'Scientific Insight'
  },
  
  // Article Titles
  "Geschichte der Hundeschule": {
    de: 'Geschichte der Hundeschule',
    en: 'History of Dog Schools'
  },
  "Wieso eine Hundeschule?": {
    de: 'Wieso eine Hundeschule?',
    en: 'Why a Dog School?'
  },
  "Woran erkennt man eine gute Hundeschule?": {
    de: 'Woran erkennt man eine gute Hundeschule?',
    en: 'How to recognize a good dog school?'
  },
  "Alles Wichtige zum Thema Hundesteuer": {
    de: 'Alles Wichtige zum Thema Hundesteuer',
    en: 'Everything Important About Dog Tax'
  },
  "Welcher Hund passt zu mir?": {
    de: 'Welcher Hund passt zu mir?',
    en: 'Which dog is right for me?'
  },
  "Grundausstattung für Ihren Hund": {
    de: 'Grundausstattung für Ihren Hund',
    en: 'Basic Equipment for Your Dog'
  },
  "Indoor-Aktivitäten für Ihren Hund": {
    de: 'Indoor-Aktivitäten für Ihren Hund',
    en: 'Indoor Activities for Your Dog'
  },
  "Warum Hundesport so wichtig ist": {
    de: 'Warum Hundesport so wichtig ist',
    en: 'Why Dog Sports Are So Important'
  },
  "Hunde allein zuhause": {
    de: 'Hunde allein zuhause',
    en: 'Dogs Home Alone'
  },
  "Nahrungsergänzungsmittel für Hunde": {
    de: 'Nahrungsergänzungsmittel für Hunde',
    en: 'Supplements for Dogs'
  },
  "BARF als Hundefutter": {
    de: 'BARF als Hundefutter',
    en: 'BARF as Dog Food'
  },
  "Naturbelassenes Hundefutter": {
    de: 'Naturbelassenes Hundefutter',
    en: 'Natural Dog Food'
  },
  "Markknochen als Hundesnack": {
    de: 'Markknochen als Hundesnack',
    en: 'Marrow Bones as Dog Snacks'
  },
  "Was ist die beste Ernährung für den Hund?": {
    de: 'Was ist die beste Ernährung für den Hund?',
    en: 'What is the best nutrition for dogs?'
  },
  "Spartipps für Tierfutter": {
    de: 'Spartipps für Tierfutter',
    en: 'Saving Tips for Pet Food'
  },
  "Zahngesundheit für Hunde": {
    de: 'Zahngesundheit für Hunde',
    en: 'Dental Health for Dogs'
  },
  "Was tun, wenn der Hund Verhaltensstörungen zeigt?": {
    de: 'Was tun, wenn der Hund Verhaltensstörungen zeigt?',
    en: 'What to do if your dog shows behavioral problems?'
  },
  "Ist ein orthopädisches Hundebett wirklich die bessere Wahl?": {
    de: 'Ist ein orthopädisches Hundebett wirklich die bessere Wahl?',
    en: 'Is an orthopedic dog bed really the better choice?'
  },
  "Hund entlaufen - so finden Sie ihn wieder": {
    de: 'Hund entlaufen - so finden Sie ihn wieder',
    en: 'Dog ran away - how to find it again'
  },
  dogBreedsTitle: {
    de: 'Die 20 beliebtesten Hunderassen im Überblick',
    en: 'Overview of the 20 Most Popular Dog Breeds'
  },
  dogBreedsDescription: {
    de: 'Entdecken Sie detaillierte Informationen zu den beliebtesten Hunderassen, ihre Charaktereigenschaften, Gesundheitsaspekte und für welche Lebenssituationen sie besonders geeignet sind.',
    en: 'Discover detailed information about the most popular dog breeds, their characteristics, health aspects, and which living situations they are particularly suited for.'
  },
  characteristics: {
    de: 'Charaktereigenschaften',
    en: 'Characteristics'
  },
  healthAspects: {
    de: 'Gesundheitliche Aspekte',
    en: 'Health Aspects'
  },
  suitability: {
    de: 'Eignung',
    en: 'Suitability'
  },
  specialFeatures: {
    de: 'Besonderheiten',
    en: 'Special Features'
  },
  lifeExpectancy: {
    de: 'Lebenserwartung',
    en: 'Life Expectancy'
  },
  toTop: {
    de: 'Zum Anfang',
    en: 'Back to Top'
  },

  // Article Content - Paragraphs, subtitles and list items
  // Geschichte der Hundeschule
  "Die Wurzeln der organisierten Hundeausbildung reichen bis in das 19. Jahrhundert zurück, als militärische und polizeiliche Organisationen begannen, systematisch Hunde für spezifische Aufgaben auszubilden. Die frühesten Hundeschulen, wie sie in Deutschland und Großbritannien entstanden, konzentrierten sich auf Gehorsamkeitstraining, das für Diensthunde unerlässlich war.": {
    de: "Die Wurzeln der organisierten Hundeausbildung reichen bis in das 19. Jahrhundert zurück, als militärische und polizeiliche Organisationen begannen, systematisch Hunde für spezifische Aufgaben auszubilden. Die frühesten Hundeschulen, wie sie in Deutschland und Großbritannien entstanden, konzentrierten sich auf Gehorsamkeitstraining, das für Diensthunde unerlässlich war.",
    en: "The roots of organized dog training date back to the 19th century, when military and police organizations began systematically training dogs for specific tasks. The earliest dog schools, such as those established in Germany and Great Britain, focused on obedience training, which was essential for service dogs."
  },
  "Pionierarbeit und Entwicklung:": {
    de: "Pionierarbeit und Entwicklung:",
    en: "Pioneering Work and Development:"
  },
  "Zu Beginn des 20. Jahrhunderts trugen Persönlichkeiten wie Konrad Most, ein deutscher Hundetrainer und Autor, maßgeblich zur Entwicklung moderner Trainingsmethoden bei. Most betonte die Bedeutung von positiver Verstärkung und individueller Anpassung des Trainings an den Hund.": {
    de: "Zu Beginn des 20. Jahrhunderts trugen Persönlichkeiten wie Konrad Most, ein deutscher Hundetrainer und Autor, maßgeblich zur Entwicklung moderner Trainingsmethoden bei. Most betonte die Bedeutung von positiver Verstärkung und individueller Anpassung des Trainings an den Hund.",
    en: "At the beginning of the 20th century, personalities such as Konrad Most, a German dog trainer and author, made significant contributions to the development of modern training methods. Most emphasized the importance of positive reinforcement and individual adaptation of training to the dog."
  },
  "In den 1950er und 1960er Jahren gewannen ethologische Studien, insbesondere die von Konrad Lorenz, an Bedeutung. Diese Studien beleuchteten das natürliche Verhalten von Hunden und beeinflussten die Trainingsansätze.": {
    de: "In den 1950er und 1960er Jahren gewannen ethologische Studien, insbesondere die von Konrad Lorenz, an Bedeutung. Diese Studien beleuchteten das natürliche Verhalten von Hunden und beeinflussten die Trainingsansätze.",
    en: "In the 1950s and 1960s, ethological studies, particularly those by Konrad Lorenz, gained importance. These studies illuminated the natural behavior of dogs and influenced training approaches."
  },
  "Die Entwicklung von Hundesportarten wie Agility in den 1970er Jahren trug dazu bei, dass Hundeschulen sich von reinen Gehorsamkeitskursen hin zu vielseitigen Trainingszentren entwickelten.": {
    de: "Die Entwicklung von Hundesportarten wie Agility in den 1970er Jahren trug dazu bei, dass Hundeschulen sich von reinen Gehorsamkeitskursen hin zu vielseitigen Trainingszentren entwickelten.",
    en: "The development of dog sports such as agility in the 1970s contributed to dog schools evolving from pure obedience courses to versatile training centers."
  },
  "Moderne Hundeschulen:": {
    de: "Moderne Hundeschulen:",
    en: "Modern Dog Schools:"
  },
  "• Heute basieren moderne Hundeschulen auf wissenschaftlichen Erkenntnissen der Verhaltensbiologie und Lernpsychologie\n• Sie bieten eine breite Palette von Kursen an, von Welpenerziehung und Gehorsamkeitstraining bis hin zu spezialisierten Sportarten und Verhaltenstherapie\n• Ein wichtiger Trend ist die Betonung von positiver Verstärkung und gewaltfreiem Training\n• Die Individualität jedes Hundes und seiner Bedürfnisse steht im Vordergrund": {
    de: "• Heute basieren moderne Hundeschulen auf wissenschaftlichen Erkenntnissen der Verhaltensbiologie und Lernpsychologie\n• Sie bieten eine breite Palette von Kursen an, von Welpenerziehung und Gehorsamkeitstraining bis hin zu spezialisierten Sportarten und Verhaltenstherapie\n• Ein wichtiger Trend ist die Betonung von positiver Verstärkung und gewaltfreiem Training\n• Die Individualität jedes Hundes und seiner Bedürfnisse steht im Vordergrund",
    en: "• Today, modern dog schools are based on scientific findings in behavioral biology and learning psychology\n• They offer a wide range of courses, from puppy training and obedience training to specialized sports and behavioral therapy\n• An important trend is the emphasis on positive reinforcement and non-violent training\n• The individuality of each dog and its needs is paramount"
  },
  
  // Wieso eine Hundeschule?
  "Eine Hundeschule bietet weit mehr als nur das Erlernen grundlegender Kommandos. Sie ist ein Ort, an dem Hunde und ihre Halter gemeinsam lernen, kommunizieren und eine starke Bindung aufbauen.": {
    de: "Eine Hundeschule bietet weit mehr als nur das Erlernen grundlegender Kommandos. Sie ist ein Ort, an dem Hunde und ihre Halter gemeinsam lernen, kommunizieren und eine starke Bindung aufbauen.",
    en: "A dog school offers much more than just learning basic commands. It is a place where dogs and their owners learn together, communicate, and build a strong bond."
  },
  "Sozialisierung und Interaktion:": {
    de: "Sozialisierung und Interaktion:",
    en: "Socialization and Interaction:"
  },
  "• In der Welpenzeit ist die Sozialisierung entscheidend für die Entwicklung eines ausgeglichenen Hundes\n• In der Hundeschule lernen Welpen, mit verschiedenen Hunden und Menschen angemessen zu interagieren\n• Erwachsene Hunde können ihre sozialen Fähigkeiten auffrischen und verbessern": {
    de: "• In der Welpenzeit ist die Sozialisierung entscheidend für die Entwicklung eines ausgeglichenen Hundes\n• In der Hundeschule lernen Welpen, mit verschiedenen Hunden und Menschen angemessen zu interagieren\n• Erwachsene Hunde können ihre sozialen Fähigkeiten auffrischen und verbessern",
    en: "• During puppyhood, socialization is crucial for the development of a balanced dog\n• In dog school, puppies learn to interact appropriately with different dogs and people\n• Adult dogs can refresh and improve their social skills"
  },
  "Praxisbeispiel: Ein ängstlicher Hund lernt in der Hundeschule, sich in der Nähe anderer Hunden zu entspannen.": {
    de: "Praxisbeispiel: Ein ängstlicher Hund lernt in der Hundeschule, sich in der Nähe anderer Hunden zu entspannen.",
    en: "Practical example: An anxious dog learns to relax around other dogs at dog school."
  },
  "Gehorsamkeit und Sicherheit:": {
    de: "Gehorsamkeit und Sicherheit:",
    en: "Obedience and Safety:"
  },
  "• Grundlegende Kommandos wie \"Sitz\", \"Platz\" und \"Hier\" sind wichtig für die Sicherheit des Hundes\n• In der Hundeschule lernen Hunde, auf die Signale ihrer Halter zu achten und zu reagieren\n• Dies erleichtert den Alltag und reduziert das Risiko von Unfällen": {
    de: "• Grundlegende Kommandos wie \"Sitz\", \"Platz\" und \"Hier\" sind wichtig für die Sicherheit des Hundes\n• In der Hundeschule lernen Hunde, auf die Signale ihrer Halter zu achten und zu reagieren\n• Dies erleichtert den Alltag und reduziert das Risiko von Unfällen",
    en: "• Basic commands such as \"sit\", \"down\" and \"here\" are important for the dog's safety\n• In dog school, dogs learn to pay attention to and respond to their handlers' signals\n• This makes everyday life easier and reduces the risk of accidents"
  },
  "Idee: Ein Kurs, der sich auf das Training für den Stadtalltag konzentriert.": {
    de: "Idee: Ein Kurs, der sich auf das Training für den Stadtalltag konzentriert.",
    en: "Idea: A course that focuses on training for urban everyday life."
  },
  "Bindung und Vertrauen:": {
    de: "Bindung und Vertrauen:",
    en: "Bonding and Trust:"
  },
  "• Das gemeinsame Training stärkt die Bindung zwischen Hund und Halter\n• Hunde lernen, ihrem Halter zu vertrauen und auf seine Führung zu vertrauen\n• Dies führt zu einem harmonischen Zusammenleben und einem glücklichen Hund": {
    de: "• Das gemeinsame Training stärkt die Bindung zwischen Hund und Halter\n• Hunde lernen, ihrem Halter zu vertrauen und auf seine Führung zu vertrauen\n• Dies führt zu einem harmonischen Zusammenleben und einem glücklichen Hund",
    en: "• Training together strengthens the bond between dog and owner\n• Dogs learn to trust their owner and rely on their guidance\n• This leads to harmonious coexistence and a happy dog"
  },
  "Verhaltensweise: Regelmäßiges, positives Training zuhause, um das Gelernte zu festigen.": {
    de: "Verhaltensweise: Regelmäßiges, positives Training zuhause, um das Gelernte zu festigen.",
    en: "Behavior: Regular, positive training at home to reinforce what has been learned."
  },
  "Verhaltensprobleme und Lösungen:": {
    de: "Verhaltensprobleme und Lösungen:",
    en: "Behavioral Problems and Solutions:"
  },
  "• Hundeschulen bieten Hilfe bei Verhaltensproblemen wie übermäßigem Bellen, Leinenaggression oder Angstzuständen\n• Qualifizierte Trainer können die Ursachen des Problems identifizieren und individuelle Lösungen anbieten": {
    de: "• Hundeschulen bieten Hilfe bei Verhaltensproblemen wie übermäßigem Bellen, Leinenaggression oder Angstzuständen\n• Qualifizierte Trainer können die Ursachen des Problems identifizieren und individuelle Lösungen anbieten",
    en: "• Dog schools offer help with behavioral problems such as excessive barking, leash aggression, or anxiety\n• Qualified trainers can identify the causes of the problem and offer individual solutions"
  },
  "Praxisbeispiel: Ein Hund, der an Trennungsangst leidet, lernt in der Hundeschule, sich zu entspannen, wenn er allein ist.": {
    de: "Praxisbeispiel: Ein Hund, der an Trennungsangst leidet, lernt in der Hundeschule, sich zu entspannen, wenn er allein ist.",
    en: "Practical example: A dog suffering from separation anxiety learns to relax when alone at dog school."
  },
  // Woran erkennt man eine gute Hundeschule?
  "Die Wahl der richtigen Hundeschule ist entscheidend für den Erfolg des Trainings. Achten Sie auf folgende Kriterien:": {
    de: "Die Wahl der richtigen Hundeschule ist entscheidend für den Erfolg des Trainings. Achten Sie auf folgende Kriterien:",
    en: "Choosing the right dog school is crucial for the success of the training. Pay attention to the following criteria:"
  },
  "Qualifizierte Trainer:": {
    de: "Qualifizierte Trainer:",
    en: "Qualified Trainers:"
  },
  "• Trainer sollten über eine fundierte Ausbildung und Erfahrung in der Hundeerziehung verfügen\n• Achten Sie auf Zertifizierungen von anerkannten Verbänden\n• Ein guter Trainer bildet sich regelmäßig fort und ist auf dem neuesten Stand der Wissenschaft": {
    de: "• Trainer sollten über eine fundierte Ausbildung und Erfahrung in der Hundeerziehung verfügen\n• Achten Sie auf Zertifizierungen von anerkannten Verbänden\n• Ein guter Trainer bildet sich regelmäßig fort und ist auf dem neuesten Stand der Wissenschaft",
    en: "• Trainers should have a solid education and experience in dog training\n• Look for certifications from recognized associations\n• A good trainer regularly educates themselves and is up to date with the latest science"
  },
  "Verhaltensweise: Ein Trainer, der sich Zeit nimmt, die individuellen Bedürfnisse jedes Hundes zu verstehen.": {
    de: "Verhaltensweise: Ein Trainer, der sich Zeit nimmt, die individuellen Bedürfnisse jedes Hundes zu verstehen.",
    en: "Behavior: A trainer who takes the time to understand the individual needs of each dog."
  },
  "Positive Verstärkung:": {
    de: "Positive Verstärkung:",
    en: "Positive Reinforcement:"
  },
  "• Moderne Hundeschulen setzen auf positive Verstärkung statt auf Bestrafung\n• Belohnungen wie Lob, Leckerlis oder Spielzeug werden eingesetzt, um erwünschtes Verhalten zu fördern\n• Dies schafft eine positive Lernatmosphäre und stärkt die Bindung zwischen Hund und Halter": {
    de: "• Moderne Hundeschulen setzen auf positive Verstärkung statt auf Bestrafung\n• Belohnungen wie Lob, Leckerlis oder Spielzeug werden eingesetzt, um erwünschtes Verhalten zu fördern\n• Dies schafft eine positive Lernatmosphäre und stärkt die Bindung zwischen Hund und Halter",
    en: "• Modern dog schools rely on positive reinforcement instead of punishment\n• Rewards such as praise, treats or toys are used to encourage desired behavior\n• This creates a positive learning atmosphere and strengthens the bond between dog and owner"
  },
  "Idee: Eine Hundeschule, die Workshops zum Thema \"Positive Verstärkung im Alltag\" anbietet.": {
    de: "Idee: Eine Hundeschule, die Workshops zum Thema \"Positive Verstärkung im Alltag\" anbietet.",
    en: "Idea: A dog school that offers workshops on the topic of \"Positive Reinforcement in Everyday Life\"."
  },
  "Kleine Gruppen:": {
    de: "Kleine Gruppen:",
    en: "Small Groups:"
  },
  "• Kleine Gruppen ermöglichen eine individuelle Betreuung und ein effektives Training\n• Der Trainer kann sich auf jeden Hund konzentrieren und individuelle Bedürfnisse berücksichtigen\n• Dies reduziert Stress und fördert den Lernerfolg": {
    de: "• Kleine Gruppen ermöglichen eine individuelle Betreuung und ein effektives Training\n• Der Trainer kann sich auf jeden Hund konzentrieren und individuelle Bedürfnisse berücksichtigen\n• Dies reduziert Stress und fördert den Lernerfolg",
    en: "• Small groups allow for individual support and effective training\n• The trainer can focus on each dog and take individual needs into account\n• This reduces stress and promotes learning success"
  },
  "Praxisbeispiel: Eine Welpengruppe mit maximal sechs Teilnehmern.": {
    de: "Praxisbeispiel: Eine Welpengruppe mit maximal sechs Teilnehmern.",
    en: "Practical example: A puppy group with a maximum of six participants."
  },
  "Saubere und sichere Umgebung:": {
    de: "Saubere und sichere Umgebung:",
    en: "Clean and Safe Environment:"
  },
  "• Die Umgebung sollte sauber und sicher für Hunde sein\n• Achten Sie auf ausreichend Platz, saubere Trainingsgeräte und eine sichere Umzäunung\n• Dies reduziert das Risiko von Verletzungen und Krankheiten": {
    de: "• Die Umgebung sollte sauber und sicher für Hunde sein\n• Achten Sie auf ausreichend Platz, saubere Trainingsgeräte und eine sichere Umzäunung\n• Dies reduziert das Risiko von Verletzungen und Krankheiten",
    en: "• The environment should be clean and safe for dogs\n• Make sure there is enough space, clean training equipment and a secure fence\n• This reduces the risk of injury and illness"
  },
  "Verhaltensweise: Eine Hundeschule, die regelmäßig die Sauberkeit ihrer Räumlichkeiten überprüft.": {
    de: "Verhaltensweise: Eine Hundeschule, die regelmäßig die Sauberkeit ihrer Räumlichkeiten überprüft.",
    en: "Behavior: A dog school that regularly checks the cleanliness of its premises."
  },
  "Probestunde:": {
    de: "Probestunde:",
    en: "Trial Lesson:"
  },
  "Nutzen Sie die Möglichkeit einer Probestunde, um die Hundeschule kennenzulernen. Beobachten Sie den Umgang der Trainer mit den Hunden und die Atmosphäre in der Gruppe. Sprechen Sie mit anderen Teilnehmern und informieren Sie sich über deren Erfahrungen.": {
    de: "Nutzen Sie die Möglichkeit einer Probestunde, um die Hundeschule kennenzulernen. Beobachten Sie den Umgang der Trainer mit den Hunden und die Atmosphäre in der Gruppe. Sprechen Sie mit anderen Teilnehmern und informieren Sie sich über deren Erfahrungen.",
    en: "Take the opportunity to take a trial lesson to get to know the dog school. Observe how the trainers interact with the dogs and the atmosphere in the group. Talk to other participants and find out about their experiences."
  },
  // Alles Wichtige zum Thema Hundesteuer
  "Die Hundesteuer ist eine kommunale Steuer, die in Deutschland von den Gemeinden erhoben wird. Sie dient der Regulierung der Hundehaltung und der Finanzierung kommunaler Aufgaben.": {
    de: "Die Hundesteuer ist eine kommunale Steuer, die in Deutschland von den Gemeinden erhoben wird. Sie dient der Regulierung der Hundehaltung und der Finanzierung kommunaler Aufgaben.",
    en: "Dog tax is a municipal tax levied by municipalities in Germany. It serves to regulate dog ownership and finance municipal tasks."
  },
  "Grundlagen und Zweck:": {
    de: "Grundlagen und Zweck:",
    en: "Basics and Purpose:"
  },
  "• Die Hundesteuer ist eine sogenannte Aufwandsteuer\n• Die Einnahmen werden für verschiedene kommunale Zwecke verwendet\n• Die Steuer dient auch der Regulierung der Hundehaltung": {
    de: "• Die Hundesteuer ist eine sogenannte Aufwandsteuer\n• Die Einnahmen werden für verschiedene kommunale Zwecke verwendet\n• Die Steuer dient auch der Regulierung der Hundehaltung",
    en: "• Dog tax is a so-called expenditure tax\n• The revenue is used for various municipal purposes\n• The tax also serves to regulate dog ownership"
  },
  "Höhe und Berechnung:": {
    de: "Höhe und Berechnung:",
    en: "Amount and Calculation:"
  },
  "• Die Höhe der Hundesteuer variiert je nach Gemeinde\n• In einigen Gemeinden gibt es unterschiedliche Steuersätze für bestimmte Rassen\n• Auch die Anzahl der gehaltenen Hunde kann die Höhe der Steuer beeinflussen": {
    de: "• Die Höhe der Hundesteuer variiert je nach Gemeinde\n• In einigen Gemeinden gibt es unterschiedliche Steuersätze für bestimmte Rassen\n• Auch die Anzahl der gehaltenen Hunde kann die Höhe der Steuer beeinflussen",
    en: "• The amount of dog tax varies depending on the municipality\n• In some municipalities there are different tax rates for certain breeds\n• The number of dogs kept can also influence the amount of tax"
  },
  "Informieren Sie sich bei Ihrer Gemeinde über die genauen Bestimmungen.": {
    de: "Informieren Sie sich bei Ihrer Gemeinde über die genauen Bestimmungen.",
    en: "Find out the exact regulations from your municipality."
  },
  "Befreiungen und Ermäßigungen:": {
    de: "Befreiungen und Ermäßigungen:",
    en: "Exemptions and Reductions:"
  },
  "• In einigen Fällen können Hundehalter von der Hundesteuer befreit werden\n• Dies gilt z.B. für Assistenzhunde, Diensthunde oder Hunde aus dem Tierheim\n• Auch Hunde, die eine bestimmte Prüfung abgelegt haben, können von der Steuer befreit werden": {
    de: "• In einigen Fällen können Hundehalter von der Hundesteuer befreit werden\n• Dies gilt z.B. für Assistenzhunde, Diensthunde oder Hunde aus dem Tierheim\n• Auch Hunde, die eine bestimmte Prüfung abgelegt haben, können von der Steuer befreit werden",
    en: "• In some cases, dog owners can be exempt from dog tax\n• This applies, for example, to assistance dogs, service dogs or dogs from the animal shelter\n• Dogs that have passed a certain test can also be exempt from tax"
  },
  "Verhaltensweise: Rechtzeitig alle notwendigen Dokumente bei der Gemeinde einreichen.": {
    de: "Verhaltensweise: Rechtzeitig alle notwendigen Dokumente bei der Gemeinde einreichen.",
    en: "Behavior: Submit all necessary documents to the municipality in good time."
  },
  "An- und Abmeldung:": {
    de: "An- und Abmeldung:",
    en: "Registration and Deregistration:"
  },
  "• Jeder Hundehalter ist verpflichtet, seinen Hund bei der Gemeinde anzumelden\n• Auch bei einem Umzug oder dem Tod des Hundes muss dies der Gemeinde gemeldet werden\n• Die An- und Abmeldung erfolgt in der Regel beim Bürgeramt oder online": {
    de: "• Jeder Hundehalter ist verpflichtet, seinen Hund bei der Gemeinde anzumelden\n• Auch bei einem Umzug oder dem Tod des Hundes muss dies der Gemeinde gemeldet werden\n• Die An- und Abmeldung erfolgt in der Regel beim Bürgeramt oder online",
    en: "• Every dog owner is obliged to register their dog with the municipality\n• The municipality must also be notified of any change of address or the death of the dog\n• Registration and deregistration usually take place at the citizens' office or online"
  },
  "Praxisbeispiel: Ein Hundehalter meldet seinen Welpen innerhalb der Frist bei der Gemeinde an.": {
    de: "Praxisbeispiel: Ein Hundehalter meldet seinen Welpen innerhalb der Frist bei der Gemeinde an.",
    en: "Practical example: A dog owner registers their puppy with the municipality within the deadline."
  },
  // Pagination section - making sure these don't duplicate with existing entries
  paginationLoadMore: {
    de: "Mehr laden",
    en: "Load more"
  },
  paginationLoadingMore: {
    de: "Lade weitere Schulen...",
    en: "Loading more schools..."
  },
  paginationAllSchoolsLoaded: {
    de: "Alle Hundeschulen geladen",
    en: "All dog schools loaded"
  },
  paginationTotal: {
    de: "gesamt",
    en: "total"
  },
  paginationErrorLoadingMore: {
    de: "Fehler beim Laden weiterer Hundeschulen",
    en: "Error loading more dog schools"
  },
  tryDifferentPostalCode: {
    de: 'Versuche es mit einer anderen Postleitzahl',
    en: 'Try a different postal code'
  }
};

